import { useLexicalEditable } from '@lexical/react/useLexicalEditable';

import { useEditorChrome } from '../core/context/EditorChromeContext';

/** True while the editor is editable and in use — when in-content controls (cell menu, image toolbar) may show. */
export const useEditorActive = (): boolean => {
  const editable = useLexicalEditable();
  const { focused } = useEditorChrome();
  return editable && focused;
};
